'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { ModalContent } from '@src/components/Modal/ModalContent';
import { useModal } from '@src/components/Modal/ModalProvider';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
export interface ModalProps {
  children: ReactNode;
  id: string;
  isPreviewing?: boolean;
  attributes?: any;
}
export const Modal = props => {
  const $ = _c(14);
  const {
    children,
    id,
    isPreviewing,
    attributes
  } = props;
  const {
    isOpen,
    setClose
  } = useModal();
  let t0;
  if ($[0] !== isPreviewing) {
    t0 = getBuilderPreviewMode().edit && isPreviewing;
    $[0] = isPreviewing;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isPreviewOpen = Boolean(t0);
  let t1;
  if ($[2] !== id || $[3] !== isOpen || $[4] !== isPreviewOpen) {
    t1 = isOpen(id) || isPreviewOpen;
    $[2] = id;
    $[3] = isOpen;
    $[4] = isPreviewOpen;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const open = Boolean(t1);
  let t2;
  if ($[6] !== id || $[7] !== setClose) {
    t2 = () => {
      setClose(id);
    };
    $[6] = id;
    $[7] = setClose;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== attributes || $[10] !== children || $[11] !== open || $[12] !== t2) {
    t3 = <ModalContent attributes={attributes} isOpen={open} onClose={t2}>{children}</ModalContent>;
    $[9] = attributes;
    $[10] = children;
    $[11] = open;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};